import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import auth, { LoginDialog } from '@ifeng-fe/ui_pc_auth';
import Header from './header';
import MainContent from './mainContent';
import Footer from './footer';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    loginId = auth.uuid();

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const {
            // content,
            content: { footer },
        } = this.props;

        return (
            <Fragment>
                <Header />
                <MainContent loginId={this.loginId} />
                <Footer content={footer} />
                <LoginDialog id={this.loginId} />
            </Fragment>
        );
    }
}

export default Layout;
